<template>
  <ul class="search-list">
    <li class="item-city" :type="language" @click="$emit('select', item)">
      <p class="icon-train-p">
        <span class="icon-train" v-if="item.GeoType === 1"></span>
        <template v-else>
          {{ $t("City") }}
        </template>
      </p>
      <p>{{ getCityName(item) }}</p>
      <!--<p v-if="item.GeoType !== 1">
        {{item.CityCode}}
      </p>-->
    </li>
    <template v-if="Stations.length > 0">
      <li
        class="item-airport"
        v-for="(itemChild, indexChild) in Stations"
        :key="indexChild"
        @click="$emit('select', itemChild)"
      >
        <div class="item-airport-details" :type="language">
          <div class="logo icon-plane-enter"></div>
          <div class="details">
            <p class="icon-train-p">
              <span class="icon-train" v-if="itemChild.GeoType === 1"></span>
              <template v-else>
                {{ $t("City") }}
              </template>
            </p>
            <p>{{ getCityName(itemChild) }}</p>
            <!--火车站不展示三字码-->
            <!--<p v-if="itemChild.GeoType !== 1">{{itemChild.CityCode}}</p>-->
          </div>
        </div>
        <!-- <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/address-picker/plane.png')})`}"></div> -->
      </li>
      <li
        class="item-airport"
        v-if="item.Stations && item.Stations.length > limit"
        @click.stop="showMore = !showMore"
      >
        <p class="look-more" :class="[showMore ? 'pick-up' : '']">
          {{ showMore ? $t("ClickShrink") : $t("More_2") }}
        </p>
      </li>
    </template>
  </ul>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    item: {
      type: Object,
      default: function() {
        return {}
      }
    },
    len: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      limit: 4,
      showMore: false
    }
  },
  computed: {
    Stations() {
      let Stations = this.item.Stations || []
      if (!this.showMore) {
        Stations = this.item.Stations ? this.item.Stations.slice(0, this.limit) : []
      }
      return Stations
    }
  },
  methods: {
    _extend() {
      this.show = !this.show
    }
  },
  components: {
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.search-list
  width 100%
  background-color $color_white
  .icon-train-p
    display flex
    >.icon-train
      display inline-flex
      width 20px
      height 20px
      background url(@/assets/image/base/address-picker/icon_train.png) no-repeat
      background-size 100% 100%
  .item-city
    @extend .flex-row
    @extend .flex-start
    width 100%
    min-height 50px
    border-bottom 1px solid $color_gray_layer
    padding 10px 0
    &:last-child
      border-bottom-width 0px
    >p
      font-size 1rem
      &:nth-child(1)
        color $color_theme
        font-weight bold
        margin-right 5px
      &:nth-child(2)
        color $color_black_text_0
        font-weight bold
        margin-right 5px
      &:nth-child(3)
        color $color_gray_text
  /*.item-city[type="EN"],.item-city[type="JAP"]
    >p
      line-height 1.4em
      font-size 0.7rem !important
      &:nth-child(1)
        border 0
        padding 0
        font-weight bold*/
  .item-city-new
    flex-wrap wrap
    position relative
    .item-city-name
      @extends .flex-start
      align-items flex-start
      word-break break-all
      line-height 1.4em
      .icon
        display inline-flex
        flex-shrink 0
        width 15px
        height 1.4em
        background url(@/assets/image/base/address-picker/inter_hotel.png) center center no-repeat
        background-size 100% 15px
        margin-right 10px
    .subtext
      padding-left 25px
      width 100%
      color $color_black_text_0
      font-size 13px
      margin-top 3px
  .item-airport
    @extend .flex-row
    @extend .flex-between
    width calc(100% - 35px)
    min-height 50px
    margin-left 35px
    border-bottom 1px solid $color_gray_layer
    &:last-child
      border-bottom-width 0
    >.item-airport-details
      @extend .flex-row
      @extend .flex-start
      width calc(100% - 25px)
      padding 10px 0
      >.logo
        margin-right 5px
      >p
        font-size 1rem
      >.details
        >p
          line-height 1.4em
          &:nth-child(1)
            @extend .no-wrap
            color $color_theme
            font-weight bold
            margin-right 5px
          &:nth-child(2)
            color $color_black_text_0
            margin-right 5px
          &:nth-child(3)
            color $color_gray_text
    >.item-airport-details[type="CN"],>.item-airport-details[type="EN"],>.item-airport-details[type="JAP"]
      >.details
        @extend .flex-row
        @extend .flex-start
    /*>.item-airport-details[type="EN"],>.item-airport-details[type="JAP"]
      >.details
        @extend .flex-column
        @extend .flex-top
        font-size 0.7rem
        >p
          &:nth-child(1)
            border 0
            padding 0
            font-weight bold*/
    >.logo
      width 20px
      height 20px
      background-size 100% 100%

  .look-more
    @extends .flex-center
    color $color_font_blue_7
    font-size 14px
    width 100%
    &::after
      display inline-flex
      content ' '
      width 20px
      height 20px
      background url(@/assets/image/base/cell/right_arrow_gray.png) no-repeat
      background-size 100% 100%
      transform rotate(90deg)
      margin-left 5px
    &.pick-up
      &::after
        background url(@/assets/image/base/cell/right_arrow_gray.png) no-repeat
        background-size 100% 100%
        transform rotate(-90deg)
</style>
